import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./auth/authSlice";
import bulkPaymentsReducer from "./bulkPayments/bulkPaymentsSlice";
import tasksReducer from "./tasks/tasksSlice";
import userReducer from "./user/userSlice";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		user: userReducer,
		tasks: tasksReducer,
		bulkPayments: bulkPaymentsReducer,
	},
});
